// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i6JTl","single":"styles_single__OIqj0"};